import { Avatar, Box, Container, Grid, Paper, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { makeStyles } from "@mui/styles";
import Helper from "../../common/Helper";
import { baseUrl } from "../../services/AzureStorage";
import BasicStatsChart from "./BasicStatsChart";
import StatsRadarChart from "./StatsRadarChart";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../common/RouteConstants";
import StatsBarChart from "./StatsBarChart";
import { useEffect } from "react";
import StatsBasicBarChart from "./StatsBasicBarChart";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "5px 15px",
    border: "1px solid lightgrey",
    borderRadius: "10px",
    boxShadow: "2px 2px 11px grey inset",
  },
  listItemIcon: {
    minWidth: "38px",
  },
  imageIcon: {
    width: "100%",
    height: "100%",
    cursor: "pointer",
  },
  iconRoot: {
    textAlign: "center",
    width: "100%",
    height: "50px",
  },
  cardStyle: {
    border: "1px solid lightgrey",
    borderRadius: "10px",
    height: "250px",
  },

  headerText: {
    marginBottom: theme.spacing(0.5),
    color: "rgb(29, 66, 138)",
  },
  headerText2: {
    marginBottom: theme.spacing(0.5),
    color: "rgb(29, 66, 138)",
  },
  headerTextInfo: {
    color: "rgb(29, 66, 138)",
    fontSize: "14px",
  },
  headerBox: {
    background: "#c1d0ed",
    borderRadius: "17px",
  },
  smBlue: {
    marginLeft: "16px",
    width: 26,
    height: 26,
    color: theme.palette.getContrastText("#0c2c75"),
    backgroundColor: "#1e3f7e",
    position: "relative",
    overflow: "hidden",
    borderRadius: "50%",
  },
  playerNameStyle: {
    cursor: "pointer",
    "&:hover": {
      color: "blue",
    },
  },
}));
export default function AdvanceStats(props) {
  const classes = useStyles();
  let navigate = useNavigate();
  const {
    priamryPlayerData,
    otherPlayerData,
    groupAvg,
    perenctileRank,
    primaryName,
    eventId,
    selectedSeasons,
  } = props;

  //BAR CHART DATA HOLDERS
  const barChartLables = selectedSeasons?.sort().reverse();
  const primaryPlayerDatatov = [];
  const groupAvgtov = [];
  const primaryPlayerDataast = [];
  const groupAvgast = [];
  const primaryPlayerDatats = [];
  const groupAvgts = [];
  const primaryPlayerDataefg = [];
  const groupAvgefg = [];
  const primaryPlayerDatastl = [];
  const groupAvgstl = [];
  const primaryPlayerDatablk = [];
  const groupAvgblk = [];
  const primaryPlayerDatadrb = [];
  const groupAvgdrb = [];
  const primaryPlayerDatadrtg = [];
  const groupAvgdrtg = [];

  barChartLables.forEach((lable) => {
    const yearWisePlayerData = priamryPlayerData?.find(
      (data) => data.seasonYear === parseInt(lable)
    );
    const yearWiseGroupAvgData = groupAvg?.find(
      (data) => data.seasonYear === parseInt(lable)
    );

    primaryPlayerDatatov.push(yearWisePlayerData?.toV_Pct || 0);
    groupAvgtov.push(yearWiseGroupAvgData?.toV_Pct || 0);
    primaryPlayerDataast.push(yearWisePlayerData?.asT_Pct || 0);
    groupAvgast.push(yearWiseGroupAvgData?.asT_Pct || 0);
    primaryPlayerDatats.push(yearWisePlayerData?.tS_Pct || 0);
    groupAvgts.push(yearWiseGroupAvgData?.tS_Pct || 0);
    primaryPlayerDataefg.push(yearWisePlayerData?.eFG_Pct || 0);
    groupAvgefg.push(yearWiseGroupAvgData?.eFG_Pct || 0);
    primaryPlayerDatastl.push(yearWisePlayerData?.stL_Pct || 0);
    groupAvgstl.push(yearWiseGroupAvgData?.stL_Pct || 0);
    primaryPlayerDatablk.push(yearWisePlayerData?.blK_Pct || 0);
    groupAvgblk.push(yearWiseGroupAvgData?.blK_Pct || 0);
    primaryPlayerDatadrb.push(yearWisePlayerData?.drB_Pct || 0);
    groupAvgdrb.push(yearWiseGroupAvgData?.drB_Pct || 0);
    primaryPlayerDatadrtg.push(yearWisePlayerData?.dRtg || 0);
    groupAvgdrtg.push(yearWiseGroupAvgData?.dRtg || 0);
  });

  var newPrimaryPlayerDatatov = [];
  var newGroupAvgtov = [];
  var newPrimaryPlayerDataast = [];
  var newGroupAvgast = [];
  var newPrimaryPlayerDatats = [];
  var newGroupAvgts = [];
  var newPrimaryPlayerDataefg = [];
  var newGroupAvgefg = [];
  var newPrimaryPlayerDatastl = [];
  var newGroupAvgstl = [];
  var newPrimaryPlayerDatablk = [];
  var newGroupAvgblk = [];
  var newPrimaryPlayerDatadrb = [];
  var newGroupAvgdrb = [];
  var newPrimaryPlayerDatadrtg = [];
  var newGroupAvgdrtg = [];
  priamryPlayerData &&
    priamryPlayerData.map((val, index) => {
      newPrimaryPlayerDatatov.push({ x: val.toV_Pct, y: val.seasonYear, r: 5 });
      newPrimaryPlayerDataast.push({ x: val.asT_Pct, y: val.seasonYear, r: 5 });
      newPrimaryPlayerDatats.push({ x: val.tS_Pct, y: val.seasonYear, r: 5 });
      newPrimaryPlayerDataefg.push({ x: val.eFG_Pct, y: val.seasonYear, r: 5 });
      newPrimaryPlayerDatastl.push({ x: val.stL_Pct, y: val.seasonYear, r: 5 });
      newPrimaryPlayerDatablk.push({ x: val.blK_Pct, y: val.seasonYear, r: 5 });
      newPrimaryPlayerDatadrb.push({ x: val.drB_Pct, y: val.seasonYear, r: 5 });
      newPrimaryPlayerDatadrtg.push({ x: val.dRtg, y: val.seasonYear, r: 5 });
    });
  groupAvg &&
    groupAvg.map((val, index) => {
      newGroupAvgtov.push({ x: val.toV_Pct, y: val.seasonYear, r: 5 });
      newGroupAvgast.push({ x: val.asT_Pct, y: val.seasonYear, r: 5 });
      newGroupAvgts.push({ x: val.tS_Pct, y: val.seasonYear, r: 5 });
      newGroupAvgefg.push({ x: val.eFG_Pct, y: val.seasonYear, r: 5 });
      newGroupAvgstl.push({ x: val.stL_Pct, y: val.seasonYear, r: 5 });
      newGroupAvgblk.push({ x: val.blK_Pct, y: val.seasonYear, r: 5 });
      newGroupAvgdrb.push({ x: val.drB_Pct, y: val.seasonYear, r: 5 });
      newGroupAvgdrtg.push({ x: val.dRtg, y: val.seasonYear, r: 5 });
    });
  const labels = [
    "TS%",
    "eFG%",
    "3PAr",
    "FTr",
    "ORB%",
    "DRB%",
    "AST%",
    "STL%",
    "BLK%",
    "TOV%",
    "USG%",
  ];
  const data = [];
  const otherPlayerdata = []; // [10,20,30,40,50,60,70];
  perenctileRank.map((val, index) => {
    if (
      val.category === "TS%" ||
      val.category === "eFG%" ||
      val.category === "3PAr" ||
      val.category === "FTr" ||
      val.category === "ORB%" ||
      val.category === "DRB%" ||
      val.category === "AST%" ||
      val.category === "STL%" ||
      val.category === "BLK%" ||
      val.category === "TOV%" ||
      val.category === "USG%"
    ) {
      data.push(val.primaryPlayerPercentile);
      otherPlayerdata.push(val.groupPercentile);
    }
  });

  const viewPlayerProfile = (playerId) => {
    navigate(`/${eventId}${RouteConstants.VIEW_PLAYER_PROFILE}/${playerId}`, {
      state: { from: "CareerStats", tab: 1 },
    });
  };

  return (
    <Container maxWidth={false}>
      <Box mt={2} mb={2}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Box display="flex" pl={2}>
              <Typography className={`${classes.headerText} headerTitle`}>
                Selected Player
              </Typography>
            </Box>
          </Box>
          <Grid container spacing={2} pt={3}>
            <TableContainer>
              {priamryPlayerData && priamryPlayerData.length > 0 && (
                <Table>
                  <TableHead>
                    <TableCell style={{ padding: "4px", paddingLeft: "25px" }}>
                      Player Name
                    </TableCell>
                    <TableCell style={{ padding: "4px" }}>Position</TableCell>
                    <TableCell style={{ padding: "4px" }}>Season</TableCell>

                    <TableCell style={{ padding: "4px" }}>TS% </TableCell>
                    <TableCell style={{ padding: "4px" }}>eFG%</TableCell>
                    <TableCell style={{ padding: "4px" }}>3PA</TableCell>
                    <TableCell style={{ padding: "4px" }}>FTr </TableCell>
                    <TableCell style={{ padding: "4px" }}>ORB%</TableCell>
                    <TableCell style={{ padding: "4px" }}>DRB%</TableCell>
                    <TableCell style={{ padding: "4px" }}>TRB%</TableCell>
                    <TableCell style={{ padding: "4px" }}>AST%</TableCell>
                    <TableCell style={{ padding: "4px" }}>STL%</TableCell>
                    <TableCell style={{ padding: "4px" }}>BLK%</TableCell>
                    <TableCell style={{ padding: "4px" }}>TOV%</TableCell>
                    <TableCell style={{ padding: "4px" }}>USG%</TableCell>
                    <TableCell style={{ padding: "4px" }}>ORtg </TableCell>
                    <TableCell style={{ padding: "4px" }}>DRtg </TableCell>
                  </TableHead>

                  <TableBody>
                    {priamryPlayerData.map((val, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell style={{ padding: "5px" }}>
                            <Box display="flex">
                              {val.headshotURL && val.headshotURL !== "" ? (
                                <Avatar
                                  className={classes.smBlue}
                                  sx={{ bgcolor: "#1d428a", cursor: "pointer" }}
                                  src={
                                    val.headshotURL
                                      ? baseUrl(val.headshotURL)
                                      : ""
                                  }
                                  alt="basketball"
                                  title="View Player Profile"
                                  onClick={() =>
                                    viewPlayerProfile(val.playerID)
                                  }
                                >
                                  <Typography variant="caption">
                                    {Helper.GetNameInitials(
                                      `${val.playerName}`
                                    )}
                                  </Typography>
                                </Avatar>
                              ) : (
                                <Avatar
                                  className={classes.smBlue}
                                  sx={{ bgcolor: "#1d428a", cursor: "pointer" }}
                                  alt="basketball"
                                  title="View Player Profile"
                                  onClick={() =>
                                    viewPlayerProfile(val.playerID)
                                  }
                                >
                                  <Typography variant="caption">
                                    {Helper.GetNameInitials(
                                      `${val.playerName}`
                                    )}
                                  </Typography>
                                </Avatar>
                              )}
                              &nbsp;&nbsp;
                              <Typography
                                variant="body2"
                                className={classes.playerNameStyle}
                                title="View Player Profile"
                                onClick={() => viewPlayerProfile(val.playerID)}
                              >
                                {val.playerName}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.position ? val.position : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.seasonYear ? val.seasonYear : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {val.tS_Pct ? val.tS_Pct : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.eFG_Pct ? val.eFG_Pct : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.threePAr ? val.threePAr : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.fTr ? val.fTr : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.orB_Pct ? val.orB_Pct : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.drB_Pct ? val.drB_Pct : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.trB_Pct ? val.trB_Pct : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.asT_Pct ? val.asT_Pct : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.stL_Pct ? val.stL_Pct : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.blK_Pct ? val.blK_Pct : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.toV_Pct ? val.toV_Pct : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.usG_Pct ? val.usG_Pct : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.oRtg ? val.oRtg : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.dRtg ? val.dRtg : "-"}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              )}
            </TableContainer>
          </Grid>
        </Paper>
      </Box>

      <Box mt={2} mb={2}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Box display="flex" pl={2}>
              <Typography className={`${classes.headerText} headerTitle`}>
                Comparison Group
              </Typography>
            </Box>
          </Box>
          <Grid container spacing={2} pt={3}>
            <TableContainer>
              {otherPlayerData && otherPlayerData.length > 0 && (
                <Table>
                  <TableHead>
                    <TableCell style={{ padding: "4px", paddingLeft: "25px" }}>
                      Player Name
                    </TableCell>
                    <TableCell style={{ padding: "4px" }}>Position</TableCell>
                    <TableCell style={{ padding: "4px" }}>Season</TableCell>
                    <TableCell style={{ padding: "4px" }}>TS% </TableCell>
                    <TableCell style={{ padding: "4px" }}>eFG%</TableCell>
                    <TableCell style={{ padding: "4px" }}>3PA</TableCell>
                    <TableCell style={{ padding: "4px" }}>FTr </TableCell>
                    <TableCell style={{ padding: "4px" }}>ORB%</TableCell>
                    <TableCell style={{ padding: "4px" }}>DRB%</TableCell>
                    <TableCell style={{ padding: "4px" }}>TRB%</TableCell>
                    <TableCell style={{ padding: "4px" }}>AST%</TableCell>
                    <TableCell style={{ padding: "4px" }}>STL%</TableCell>
                    <TableCell style={{ padding: "4px" }}>BLK%</TableCell>
                    <TableCell style={{ padding: "4px" }}>TOV%</TableCell>
                    <TableCell style={{ padding: "4px" }}>USG%</TableCell>
                    <TableCell style={{ padding: "4px" }}>ORtg </TableCell>
                    <TableCell style={{ padding: "4px" }}>DRtg </TableCell>
                  </TableHead>
                  <TableBody>
                    {otherPlayerData.map((val, index) => {
                      var avg = false;
                      if (val.playerName === "AVG") {
                        avg = true;
                      }
                      return (
                        <TableRow
                          sx={{ backgroundColor: avg ? "#F5F5F5" : "white" }}
                          key={index}
                        >
                          <TableCell style={{ padding: "5px" }}>
                            {avg ? (
                              ""
                            ) : (
                              <Box display="flex">
                                {val.headshotURL && val.headshotURL !== "" ? (
                                  <Avatar
                                    className={classes.smBlue}
                                    sx={{
                                      bgcolor: "#1d428a",
                                      cursor: "pointer",
                                    }}
                                    src={
                                      val.headshotURL
                                        ? baseUrl(val.headshotURL)
                                        : ""
                                    }
                                    alt="basketball"
                                    title="View Player Profile"
                                    onClick={() =>
                                      viewPlayerProfile(val.playerID)
                                    }
                                  >
                                    <Typography variant="caption">
                                      {Helper.GetNameInitials(
                                        `${val.playerName}`
                                      )}
                                    </Typography>
                                  </Avatar>
                                ) : (
                                  <Avatar
                                    className={classes.smBlue}
                                    sx={{
                                      bgcolor: "#1d428a",
                                      cursor: "pointer",
                                    }}
                                    alt="basketball"
                                    title="View Player Profile"
                                    onClick={() =>
                                      viewPlayerProfile(val.playerID)
                                    }
                                  >
                                    <Typography variant="caption">
                                      {Helper.GetNameInitials(
                                        `${val.playerName}`
                                      )}
                                    </Typography>
                                  </Avatar>
                                )}
                                &nbsp;&nbsp;
                                <Typography
                                  variant="body2"
                                  className={classes.playerNameStyle}
                                  title="View Player Profile"
                                  onClick={() =>
                                    viewPlayerProfile(val.playerID)
                                  }
                                >
                                  {val.playerName}
                                </Typography>
                              </Box>
                            )}
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            {avg ? (
                              ""
                            ) : (
                              <Typography variant="caption">
                                {" "}
                                {val.position ? val.position : "-"}
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.seasonYear ? val.seasonYear : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {val.tS_Pct ? val.tS_Pct : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.eFG_Pct ? val.eFG_Pct : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.threePAr ? val.threePAr : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.fTr ? val.fTr : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.orB_Pct ? val.orB_Pct : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.drB_Pct ? val.drB_Pct : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.trB_Pct ? val.trB_Pct : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.asT_Pct ? val.asT_Pct : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.stL_Pct ? val.stL_Pct : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.blK_Pct ? val.blK_Pct : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.toV_Pct ? val.toV_Pct : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.usG_Pct ? val.usG_Pct : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.oRtg ? val.oRtg : "-"}
                            </Typography>
                          </TableCell>
                          <TableCell style={{ padding: "4px" }}>
                            <Typography variant="caption">
                              {" "}
                              {val.dRtg ? val.dRtg : "-"}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              )}
            </TableContainer>
          </Grid>
        </Paper>
      </Box>
      <Grid container spacing={2}>
        <Grid item md={6} sm={12} xs={12} justifyContent="center">
          {perenctileRank.length > 0 ? (
            <StatsRadarChart
              labels={labels}
              data={data}
              name={primaryName}
              otherPlayerdata={otherPlayerdata}
              nameotherplayer={"Comparison Group"}
            />
          ) : (
            ""
          )}
        </Grid>
        <Grid item md={6} sm={12} xs={12} justifyContent="center">
          {perenctileRank.length > 0 ? (
            <StatsBasicBarChart
              labels={labels}
              priamryPlayerData={data}
              primaryPlayerName={primaryName}
              otherPlayerdata={otherPlayerdata}
              nameotherplayer={"Comparison Group"}
              chartName={""}
            />
          ) : (
            ""
          )}
        </Grid>
      </Grid>
      <Box mt={2} mb={2}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Box display="flex" pl={2}>
              <Typography className={`${classes.headerText} headerTitle`}>
                Advance Statistics - Offensive Factors
              </Typography>
            </Box>
          </Box>
          {/* ================== BAR CHART ======================== */}
          <Grid container spacing={2}>
            <Grid item md={6} sm={12} xs={12}>
              {primaryPlayerDatatov?.length > 0 &&
              priamryPlayerData?.length > 0 ? (
                <StatsBarChart
                  priamryPlayerData={primaryPlayerDatatov}
                  groupAvg={groupAvgtov}
                  chartName={"TOV%"}
                  name={primaryName}
                  labels={barChartLables}
                />
              ) : null}
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              {primaryPlayerDataast?.length > 0 &&
              priamryPlayerData?.length > 0 ? (
                <StatsBarChart
                  priamryPlayerData={primaryPlayerDataast}
                  groupAvg={groupAvgast}
                  chartName={"AST%"}
                  name={primaryName}
                  labels={barChartLables}
                />
              ) : null}
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              {primaryPlayerDatats?.length > 0 &&
              priamryPlayerData?.length > 0 ? (
                <StatsBarChart
                  priamryPlayerData={primaryPlayerDatats}
                  groupAvg={groupAvgts}
                  chartName={"TS%"}
                  name={primaryName}
                  labels={barChartLables}
                />
              ) : null}
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              {primaryPlayerDataefg?.length > 0 &&
              priamryPlayerData?.length > 0 ? (
                <StatsBarChart
                  priamryPlayerData={primaryPlayerDataefg}
                  groupAvg={groupAvgefg}
                  chartName={"eFG%"}
                  name={primaryName}
                  labels={barChartLables}
                />
              ) : null}
            </Grid>
          </Grid>{" "}
          {/* ==================== BAR CHART ========================= */}
          {/* <Grid container spacing={2}>
            <Grid item md={6} sm={12} xs={12}>
              {newPrimaryPlayerDatatov.length > 0 &&
              priamryPlayerData.length > 0 ? (
                <BasicStatsChart
                  priamryPlayerData={newPrimaryPlayerDatatov}
                  groupAvg={newGroupAvgtov}
                  chartName={"TOV%"}
                  name={primaryName}
                />
              ) : null}
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              {newPrimaryPlayerDataast.length > 0 ? (
                <BasicStatsChart
                  priamryPlayerData={newPrimaryPlayerDataast}
                  groupAvg={newGroupAvgast}
                  chartName={"AST%"}
                  name={primaryName}
                />
              ) : null}
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              {newPrimaryPlayerDatats.length > 0 ? (
                <BasicStatsChart
                  priamryPlayerData={newPrimaryPlayerDatats}
                  groupAvg={newGroupAvgts}
                  chartName={"TS%"}
                  name={primaryName}
                />
              ) : null}
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              {newPrimaryPlayerDataefg.length > 0 ? (
                <BasicStatsChart
                  priamryPlayerData={newPrimaryPlayerDataefg}
                  groupAvg={newGroupAvgefg}
                  chartName={"eFG%"}
                  name={primaryName}
                />
              ) : null}
            </Grid>
          </Grid>{" "} */}
        </Paper>
      </Box>

      <Box mt={2} mb={2}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Box display="flex" pl={2}>
              <Typography className={`${classes.headerText} headerTitle`}>
                Advance Statistics - Defensive Factors
              </Typography>
            </Box>
          </Box>
          {/* ==================== BAR CHART ========================= */}
          <Grid container spacing={2}>
            <Grid item md={6} sm={12} xs={12}>
              {primaryPlayerDatastl?.length > 0 &&
              priamryPlayerData?.length > 0 ? (
                <StatsBarChart
                  priamryPlayerData={primaryPlayerDatastl}
                  groupAvg={groupAvgstl}
                  chartName={"STL%"}
                  name={primaryName}
                  labels={barChartLables}
                />
              ) : null}
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              {primaryPlayerDatablk?.length > 0 &&
              priamryPlayerData?.length > 0 ? (
                <StatsBarChart
                  priamryPlayerData={primaryPlayerDatablk}
                  groupAvg={groupAvgblk}
                  chartName={"BLK%"}
                  name={primaryName}
                  labels={barChartLables}
                />
              ) : null}
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              {primaryPlayerDatadrb?.length > 0 &&
              priamryPlayerData?.length > 0 ? (
                <StatsBarChart
                  priamryPlayerData={primaryPlayerDatadrb}
                  groupAvg={groupAvgdrb}
                  chartName={"DRB%"}
                  name={primaryName}
                  labels={barChartLables}
                />
              ) : null}
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              {primaryPlayerDatadrtg?.length > 0 &&
              priamryPlayerData?.length > 0 ? (
                <StatsBarChart
                  priamryPlayerData={primaryPlayerDatadrtg}
                  groupAvg={groupAvgdrtg}
                  chartName={"DRtg"}
                  name={primaryName}
                  labels={barChartLables}
                />
              ) : null}
            </Grid>
          </Grid>{" "}
          {/* ==================== BAR CHART ========================= */}
          {/* <Grid container spacing={2}>
            <Grid item md={6} sm={12} xs={12}>
              {newPrimaryPlayerDatastl.length > 0 ? (
                <BasicStatsChart
                  priamryPlayerData={newPrimaryPlayerDatastl}
                  groupAvg={newGroupAvgstl}
                  chartName={"STL%"}
                  name={primaryName}
                />
              ) : null}
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              {newPrimaryPlayerDatablk.length > 0 ? (
                <BasicStatsChart
                  priamryPlayerData={newPrimaryPlayerDatablk}
                  groupAvg={newGroupAvgblk}
                  chartName={"BLK%"}
                  name={primaryName}
                />
              ) : null}
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              {newPrimaryPlayerDatadrb.length > 0 ? (
                <BasicStatsChart
                  priamryPlayerData={newPrimaryPlayerDatadrb}
                  groupAvg={newGroupAvgdrb}
                  chartName={"DRB%"}
                  name={primaryName}
                />
              ) : null}
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              {newPrimaryPlayerDatadrtg.length > 0 ? (
                <BasicStatsChart
                  priamryPlayerData={newPrimaryPlayerDatadrtg}
                  groupAvg={newGroupAvgdrtg}
                  chartName={"DRtg"}
                  name={primaryName}
                />
              ) : null}
            </Grid>
          </Grid>{" "} */}
        </Paper>
      </Box>
      {/* <Loader isLoading={loading} /> */}
    </Container>
  );
}
